<template>
  <div>
    <!--              label="title"-->
    <v-select ref="vue_select"
              v-model="drug"
              :getOptionLabel="opt => opt"
              @keypress.enter.native.prevent=""
              @input="select"
              placeholder="Препарат"
              :filterable="false"
              :options="options"
              @search="onSearchDrug">
      <template slot="no-options">
        введите название препарата..
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center">
          {{ option.title }}
          <template v-if="option.substance">:: {{ option.substance }}</template>
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        {{ option.title }}
        <template v-if="option.substance">:: {{ option.substance }}</template>
      </template>
    </v-select>
    <div v-if="showOptions" class="mt-1">
      <pulse-loader :loading="searchLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
      <button @click="selectDrugFromOptions(o)" class="btn btn-default mb-1 w-100" type="button"
              v-for="(o, i) in options" v-if="i < 8">
        {{ o.title }}
      </button>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  props: [
    'onSelect', 'showOptions', 'extDrug', 'drugsForSearch', 'selectedDrug', 'storeIdRequest', 'searchOptions', 'minHeight'
  ],
  data() {
    return {
      drug: null,
      searchLoading: false,
      options: [],
    }
  },
  watch: {
    'extDrug': {
      handler: function (val, oldVal) {
        if (this.extDrug.id) this.drug = this.extDrug;
      },
      deep: true
    },
    'selectedDrug': {
      handler: function (val, oldVal) {
        if (!this.selectedDrug) this.drug = null;
        this.drug = {...this.selectedDrug}
      },
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters["orders/editNewOrder"];
    },
  },
  mounted() {
    if (this.selectedDrug) {
      this.drug = {...this.selectedDrug};
    }
    if (this.minHeight) {
      const input = document.getElementsByClassName("vs__dropdown-toggle");
      if (input && input[0]) input[0].style.minHeight = this.minHeight + 'px';
    }
    if ((this.drugsForSearch ?? []).length) {
      this.options = [...this.drugsForSearch];
    }
  },
  methods: {
    selectDrugFromOptions(drug) {
      this.drug = drug;
      this.select(drug);
    },
    select(e) {
      if (this.onSelect) {
        this.onSelect(e);
      }
      if (this.showOptions && !e) this.options = [];
    },
    onSearchDrug(search, loading) {
      if (!this.drugsForSearch && (!search || search.length < 4)) {
        this.searchLoading = false;
        return;
      }
      loading(true);
      this.searchLoading = true;
      this.search(loading, search, this);
    },
    search: _.debounce(async (loading, search, vm) => {
      let data = {success: true};
      if ((vm.drugsForSearch ?? []).length) {
        const searchText = search.toLowerCase();
        if (!searchText) {
          data.drugs = [...vm.drugsForSearch];
        } else {
          data.drugs = vm.drugsForSearch.filter((d) => d.title.toLowerCase().match(searchText));
        }
      } else {
        const response = await api.post('/new/drugs/search', {
          searchTitle: search,
          noPrices: !vm.searchOptions?.getPrices,
          storeId: vm.storeIdRequest,
          searchOptions: vm.searchOptions,
        });
        data = {...(response?.data ?? {})};
      }
      if (data.success) {
        if (vm.$editNewOrder.id) {
          const selectedDrugId = vm.$editNewOrder.drugs.map((d) => d.id);
          vm.options = data.drugs.filter((d) => !selectedDrugId.includes(d.id));
        } else {
          vm.options = data.drugs
        }
        if (vm.searchOptions) {
          if (data.invoices) {
            vm.options.forEach((o, i) => {
              const invoice = Object.values(data.invoices).find((i) => i.drug_id === o.id)
              if (invoice) {
                vm.options[i].lastIncomeInvoice = invoice;
              }
            })
          }
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      loading(false);
      vm.searchLoading = false;
    }, 300),
  }
}

</script>

<style>
.drug_select.custom .vs__selected {
  /*display: block;*/
}

.vs__dropdown-toggle {
  height: auto !important;
  max-height: 117px;
  min-height: 38px;
}

.drug_select .vs__search {
  z-index: 0 !important;
}

.drug_select .vs__dropdown-toggle {
  height: 38px;
  border-radius: 0;
}
</style>

<style scoped>
.drug_select_div .badge.badge-success {
  color: white;
}

.drug_select_div .d-center {
  display: flex;
  align-items: center;
}

</style>
